
import { mapState, mapMutations } from "vuex";
import { Careers } from "@/graphql/careers";

export default {
  nuxtI18n: {
    paths: {
      "en-ca": "/careers",
      "fr-ca": "/carrieres",
    },
  },
  async asyncData({ app, i18n }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();
    const careersResponse = await client.query({
      query: Careers,
      variables: { locale: locale },
    });
    const carriere = careersResponse.data.carriere.data.attributes;
    return { carriere };
  },
  data() {
    return {
      carriere: {},
      show: false,
      anchorSelected: "",
    };
  },
  head() {
    return {
      title: this.carriere.SEO.MetaTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.carriere.SEO.MetaDescription,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.carriere.SEO.MetaDescription,
        },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  computed: {
    ...mapState(["pageScroll"]),
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
  },
  watch: {
    pageScroll: function () {
      //Ajouter - le height du Header fix apres le bottom
      let haveShow = false;
      if (
        this.$refs.animated?.getBoundingClientRect().bottom -
          window.innerHeight +
          100 <=
        0
      ) {
        this.show = true;
        haveShow = true;
      }
    },
  },
};
